module.exports = __webpack_public_path__ + "img/grammar-test.0e651ff6.jpeg";